export const debounce = (func, delay = 300) => {
  let inDebounce;
  return function(...rest) {
    const context = this;
    const args = rest;
    clearTimeout(inDebounce);
    inDebounce = setTimeout(() => func.apply(context, args), delay);
  };
};
